import { render, staticRenderFns } from "./ChartGaia.vue?vue&type=template&id=3081fa87"
import script from "./ChartGaia.vue?vue&type=script&lang=js"
export * from "./ChartGaia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports